export const SUBSCRIPTION_ANALYTICS_ACCESS_DEFAULTS = {
  monitoring: false,
  group_report: false,
  dynamic_report: false,
  benchmark_report: false,
};

export const SUBSCRIPTION_ANALYTICS_ACCESS_OPTIONS = [
  { key: 'monitoring', label: 'Мониторинг' },
  { key: 'group_report', label: 'Сравнение групп' },
  { key: 'dynamic_report', label: 'Аналитика изменений' },
  { key: 'benchmark_report', label: 'Бенчмарк' },
];

export const getDefaultSubscriptionAnalyticsAccess = () => ({
  ...SUBSCRIPTION_ANALYTICS_ACCESS_DEFAULTS,
});

export const getReportAnalyticsAccessKey = (reportType) => {
  return `${reportType}_report`;
};

export const hasSubscriptionAnalyticsAccess = (subscriptions, accessKey) => {
  return subscriptions && subscriptions.some((subscription) => (
    subscription.analytics_access?.[accessKey] === true
  ));
};
